import {
    useMutation,
    useQuery,
} from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Delete, Get, Post, Put } from "../api";
import API_CONSTANTS from "../constants/api";
import { appendQueryParams } from "../helpers/queryHelper";;

export const useCohortVariantTypes = (params) => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["cohortVariantTypes", params],
        queryFn: async () => {
            const { data } = await Get({
                path: `${API_CONSTANTS.COHORT_VARIANTS_TYPES.base}?${appendQueryParams({params})}`,
                token,
                toastError: true
            })
            return data
        },
        keepPreviousData: true
    })
}

export const useCohortVariantTypesFacet = () => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["cohortVariantTypesFacet"],
        queryFn: async () => {
            const { data } = await Get({
                path: API_CONSTANTS.COHORT_VARIANTS_TYPES.getFacet,
                token,
                toastError: true,
            })
            return data
        },
    })
}

export const useCohortVariantTypeOptions = (params = {}) => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["cohortVariantTypeOptions", params],
        queryFn: async () => {
            const { data } = await Get({
                path: `${API_CONSTANTS.COHORT_VARIANTS_TYPES.getOptions}?${appendQueryParams({params})}`,
                token,
                toastError: true,
            })
            return data
        },
    })
}

export const useCreateCohortVariantType = () => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (body) => {
            const { data } = await Post({
                path: API_CONSTANTS.COHORT_VARIANTS_TYPES.base,
                token,
                body
            })
            return data
        },
    })
}

export const useUpdateCohortVariantType = (id) => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (body) => {
            const { data } = await Put({
                path: `${API_CONSTANTS.COHORT_VARIANTS_TYPES.base}/${id}`,
                token,
                body
            })
            return data
        },
    })
}

export const useDeleteCohortVariantType = () => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (id) => {
            const { data } = await Delete({
                path: `${API_CONSTANTS.COHORT_VARIANTS_TYPES.base}/${id}`,
                token,
                toastError: true,
                toastMessage: true
            })
            return data
        },
    })
}